import React, {useMemo} from "react";
import {useHtmlClassService} from "../../_core/MetronicLayout";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column app-footer ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a
            href="https://bankcardassociates.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Bankcard Associates
          </a>&nbsp;|&nbsp;
          <a
            href="https://bankcardassociates.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Privacy Policy
          </a>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          <span>Contact us at:&nbsp;</span>
          <a
            href="mailto: support@billtexting.com;"
            rel="support@billtexting.com"
            target="_blank"
            className="text-dark-75 text-hover-primary"
          >
            support@billtexting.com
          </a>
        </div>
      </div>
    </div>
  );
}
